var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#18A4E0;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,55c-1.2,0-2.4-0.5-3.2-1.5C20.7,46.8,10.5,34.1,10.5,25v-0.4C10.5,13.8,19.2,5,30,5s19.5,8.8,19.5,19.5V25 c0,9.1-10.2,21.8-16.3,28.6C32.4,54.5,31.2,55,30,55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30,31.7c-3.9,0-7-3.1-7-7l0,0l0,0c0-3.9,3.1-7,7-7s7,3.1,7,7S33.9,31.7,30,31.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMarker);
export default __webpack_public_path__ + "static/media/ic_marker.225d500edb09d601bedcba02d9237d81.svg";
export { ForwardRef as ReactComponent };